var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading-bar" }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("quiz.loading.title")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "loading__steps" },
      _vm._l(_vm.progressbarSteps, function(step) {
        return _c("div", { key: step.name, staticClass: "step" }, [
          _c("div", { staticClass: "step__header" }, [
            _c("p", [_vm._v(_vm._s(step.name))]),
            _vm._v(" "),
            _c("div", { staticClass: "percentage" }, [
              _vm._v(_vm._s(Math.round(step.progress)) + "%")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "progress" }, [
            _c("div", {
              staticClass: "current-progress",
              style: { width: step.progress + "%" }
            })
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }